export default function auth({
    next,
    router
}) {
    if (localStorage.getItem('isVerified') == 'true') return router.push({
        name: 'home'
    });

    return next();
}